import { Icon } from "@iconify/react";
import type { RecordDuplicates, RecordSource } from "@/features/patient/records/api/dataPipelineApi";

/**
 * "Found in N records": the same clinical record came from several uploads or
 * syncs and the patient's pages show it once (see the backend's
 * patient_records/duplicates.py). A plain label, not a button, so it can sit
 * inside clickable rows.
 */

export function sourceName(source: RecordSource): string {
  return source.sourceLabel || source.sourceVendor || "Unknown source";
}

export function FoundInRecordsTag({ duplicates }: { duplicates: RecordDuplicates | null | undefined }) {
  if (!duplicates || duplicates.count < 2) return null;
  const names = duplicates.sources.map(sourceName).join(", ");
  return (
    <span
      data-testid="found-in-records"
      title={`Found in: ${names}`}
      className="inline-flex items-center gap-1 rounded-full bg-[#EEF2F7] px-2 py-0.5 text-[10px] font-bold text-[#0A2947]"
    >
      <Icon icon="lucide:layers" className="h-3 w-3" />
      Found in {duplicates.count} records
    </span>
  );
}
